import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { GdxChipPage } from './gdx-chip';

@NgModule({
  declarations: [
    GdxChipPage,
  ],
  imports: [
    IonicPageModule.forChild(GdxChipPage),
  ],
})
export class GdxChipPageModule {}



// WEBPACK FOOTER //
// ./src/pages/gdx-chip/gdx-chip.module.ts